export default { sha: 'a662a488be006cdc7c6f20a18f2a4232d4578a73', buildNumber: 'undefined' }
